import { RouteInfo } from '../sidebar.metadata';

export const ROUTES: RouteInfo[] = [
];
